export const pathNameLink = [
  {
    sectionName: "index",
    color: "var(--accent-color-cream)",
    items: [
      {
        itemName: "index",
        contentItem: "",
      },
    ],
  },
  {
    sectionName: "formación-experiencia",
    color: "var(--accent-color-dark-purple)",
    items: [
      {
        itemName: "experiencia_laboral",
        contentItem: [
          {
            titulo:
              "TECH LEAD BACKEND DEVELOPER SPECIALIST - RIMAC SEGUROS Y REASEGUROS (Enero 2025 - Presente)",
            cuerpo:
              "• Lidero equipos de ingeniería backend responsables de construir y mantener plataformas empresariales de alta disponibilidad.\n• Defino la arquitectura técnica y guío la implementación de soluciones basadas en microservicios y AWS CDK (EKS, Step Functions).\n• Gestión y definición de actividades: Responsable de la definición de tareas y requerimientos técnicos, asegurando el aterrizaje funcional de las necesidades de negocio.\n• Documentación y Estimación: Elaboro documentación técnica detallada y realizo la estimación de tiempos de desarrollo, optimizando los recursos para cumplir con el time-to-market.\n• Defino estándares de desarrollo, buenas prácticas y lineamientos de arquitectura, integrando estrategias de resiliencia (Circuit Breaker, Fallbacks).\n• Coordino múltiples frentes de desarrollo asegurando el cumplimiento de entregables y la máxima calidad técnica.\n• Participo en la toma de decisiones críticas y apoyo la optimización de procesos mediante herramientas BPM (Camunda) y el uso de IA para optimizar desarrollos manuales.",
          },
          {
            titulo:
              "ANALISTA TÉCNICO BACKEND SSR - INDRA (Julio 2023 - Diciembre 2024)",
            cuerpo:
              "• Desarrollo de servicios backend utilizando Node.js, TypeScript y AWS (APIGW, EventBridge, SQS).\n• Diseño de APIs e integración de múltiples servicios cloud y herramientas de seguridad (Cognito).\n• Trabajo con bases de datos relacionales (RDS) y NoSQL (DynamoDB, Redis) para garantizar rendimiento.\n• Participación en equipos ágiles Scrum gestionando tareas mediante Jira.",
          },
          {
            titulo:
              "ANALISTA DE INCIDENTES / FULLSTACK DEVELOPER - CHAZKI (Mayo 2022 - Julio 2023)",
            cuerpo:
              "• Coordinación técnica del equipo de soporte y asignación de tareas (1 año liderando el frente operativo).\n• Análisis y resolución de incidentes en plataformas operativas, implementando monitoreo proactivo.\n• Desarrollo de herramientas de automatización para mejorar tiempos de resolución.\n• Uso de tecnologías como React, Node.js, PostgreSQL, MongoDB y Google Cloud.",
          },
          {
            titulo:
              "ANALISTA PROGRAMADOR FULL STACK - ODYBANK (Octubre 2021 - Marzo 2022)",
            cuerpo:
              "• Desarrollo de aplicaciones para el sector financiero y pasarelas de pago (Cliente: UNIBANCA).\n• Gestión de lógica compleja en transacciones, abonos y seguimiento de demoras operativas.\n• Trabajo con Java Spring Boot, Angular y bases de datos SQL para optimizar flujos de negocio.",
          },
        ],
      },
      {
        itemName: "formación_academica",
        contentItem: [
          {
            titulo:
              "INGENIERÍA DE SISTEMAS - UNIVERSIDAD NACIONAL MAYOR DE SAN MARCOS",
            cuerpo:
              "Bachiller en Ingeniería de Sistemas por la Universidad Nacional Mayor de San Marcos (UNMSM). Egresado de la carrera con conocimientos sólidos en gestión, diseño y desarrollo de sistemas de información.",
          },
        ],
      },
    ],
  },
  {
    sectionName: "aptitudes",
    color: "var(--accent-color-green)",
    items: [
      {
        itemName: "creativo",
        contentItem: [
          {
            titulo: "",
            cuerpo:
              "Al ser curioso, encontrar el porque de algo con soluciones que suelen salir de lo comun es parte de mis pasiones.",
          },
        ],
      },
      {
        itemName: "analítico",
        contentItem: [
          {
            titulo: "",
            cuerpo:
              "Evaluar cada opción o posible solución a algún problema, para así poder elegir la mas optima.",
          },
        ],
      },
    ],
  },
];
